import { c as _c } from "react/compiler-runtime";
import { Popover } from '@base-ui/react/popover';
import { Icon } from '@petsmart-ui/sparky';
import { type RefObject } from 'react';
import { AccountButton } from '../../../account-button';
import { splitTriggerProps } from './split-trigger-props';
type TriggerRender = Extract<Popover.Trigger.Props['render'], (...args: never[]) => unknown>;
type TriggerProps = {
  accountHref: string;
  isDesktop: boolean;
  onTriggerClick?: () => void;
  onClose: () => void;
  onKeyboardOpen: () => void;
  openedWithKeyboard: boolean;
  props: Parameters<TriggerRender>[0];
  state: Parameters<TriggerRender>[1];
  toggleRef: RefObject<HTMLButtonElement | null>;
};
export function Trigger(t0) {
  const $ = _c(27);
  const {
    accountHref,
    isDesktop,
    onTriggerClick,
    onClose,
    onKeyboardOpen,
    openedWithKeyboard,
    props,
    state,
    toggleRef
  } = t0;
  let t1;
  if ($[0] !== isDesktop || $[1] !== onClose || $[2] !== onKeyboardOpen || $[3] !== props || $[4] !== state.open || $[5] !== toggleRef) {
    t1 = splitTriggerProps({
      isOpen: state.open,
      onClose,
      onKeyboardOpen,
      openOnArrowDown: isDesktop,
      props,
      toggleRef
    });
    $[0] = isDesktop;
    $[1] = onClose;
    $[2] = onKeyboardOpen;
    $[3] = props;
    $[4] = state.open;
    $[5] = toggleRef;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    buttonProps,
    groupProps
  } = t1;
  if (!isDesktop) {
    let t2;
    if ($[7] !== buttonProps) {
      t2 = <AccountButton {...buttonProps} />;
      $[7] = buttonProps;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== groupProps || $[10] !== t2) {
      t3 = <div {...groupProps} className="account-popover__control">{t2}</div>;
      $[9] = groupProps;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t2 = state.open && !openedWithKeyboard ? "" : undefined;
  let t3;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon name="account-circle-outline" size="lg" aria-hidden="true" />;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== accountHref || $[14] !== onTriggerClick) {
    t4 = <a href={accountHref} className="account-popover__link" aria-label="Account" onClick={onTriggerClick}>{t3}</a>;
    $[13] = accountHref;
    $[14] = onTriggerClick;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const t5 = state.open && openedWithKeyboard ? "" : undefined;
  const t6 = state.open ? "chevron-up" : "chevron-down";
  let t7;
  if ($[16] !== t6) {
    t7 = <Icon name={t6} size="sm" aria-hidden="true" />;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== buttonProps || $[19] !== t5 || $[20] !== t7) {
    t8 = <button {...buttonProps} type="button" className="account-popover__toggle" data-keyboard-open={t5}>{t7}</button>;
    $[18] = buttonProps;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== groupProps || $[23] !== t2 || $[24] !== t4 || $[25] !== t8) {
    t9 = <div {...groupProps} className="account-popover__control" data-pointer-open={t2}>{t4}{t8}</div>;
    $[22] = groupProps;
    $[23] = t2;
    $[24] = t4;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}